import _findIndex from 'lodash/findIndex';

// TODO: refactor to use src/components/manage/EditWebsite/pages/common/EditPageMainDetails/content.ts
export const CmsPageTypes = [
  {
    value: 'WEDDING_PARTY',
    descriptionPlaceholder: 'Meet our family and friends who are walking down the aisle with us.',
  },
  {
    value: 'EVENT',
    descriptionPlaceholder:
      "Here's what to expect during our wedding weekend. There will also be a printout of this schedule available in your hotel rooms. We can't wait to celebrate with you!",
  },
  {
    value: 'TRAVEL',
    descriptionPlaceholder:
      'Flight options, hotel blocks and more recs for our out-of-towner guests.',
  },
  {
    value: 'PHOTO',
    descriptionPlaceholder: 'A few photos of us over the years.',
  },
  {
    value: 'FAQ',
    descriptionPlaceholder:
      "If you have any other questions other than what we've listed here, please reach out to our wedding planner, Annie, at 555-555-5555.",
  },
  {
    value: 'POI',
    descriptionPlaceholder:
      "We're so excited to share a few of our favorite places in the area with you.",
  },
  {
    value: 'RSVP',
    descriptionPlaceholder:
      'Please let us know your plans by May 1, 2019. We hope we get to celebrate together!',
  },
  {
    value: 'REGISTRY',
    descriptionPlaceholder:
      "Your presence is gift enough, but if you're feeling particularly generous, these are a few things we'd love to have as newlyweds.",
  },
];

export const getCmsPage = pageType => {
  const idx = _findIndex(CmsPageTypes, elem => elem.value === pageType);
  return idx >= 0 ? CmsPageTypes[idx] : null;
};

export const getCmsPageDescriptionPlaceholder = pageType => {
  const cmsPage = getCmsPage(pageType);
  if (cmsPage) {
    return cmsPage.descriptionPlaceholder || '';
  }
  return '';
};
